// first 2 characters of tooltip content define the position.  
// l, is left tooltip while b, is bottom tooltip

import React, { useContext } from 'react'
import { UserContext } from './UserContext'
import Tippy from '@tippyjs/react'
// import 'tippy.js/dist/tippy.css'

const SelectBox = ({ optionList, value, name, suffix, sbChanged, tooltipContent }) => {

    const { rdd, globalTextSize, browserH, browserW } = useContext(UserContext)


    var textAligncustom = 'left';
    if (name === 'minMFEfilters') textAligncustom = 'center';
    var selectHeight = '2.4vh';
    var selectWidth = '5vw';

    var selectBackgroundColor = 'white';
    var selectFontSize = globalTextSize;
    var suffix2 = suffix; // added to make changes for tablet portrait 8/31/2022

    if (name === 'portfolios') selectWidth = '11vw'; // desktop for portfolios


    if (rdd.isMobile && !rdd.isTablet && window.innerHeight > window.innerWidth) { // smartphone portrait
        selectHeight = '3.7vh';
        selectWidth = '18vw';
        switch (name) {
            case 'filter':
                selectWidth = '35vw';
                break;
            case 'years':
                selectWidth = '20vw';
                break;
            case 'partialYears':
                selectWidth = '24vw';
                break;
            case 'securityTypeListP':
                selectWidth = '13em';
                break;
            case 'securityTypeList':
                selectWidth = '40vw';
                break;
            case 'months':
                selectWidth = '15vw';
                break;
            case 'selectedDays': // this is in populate portfolio
                selectWidth = '14vw';
                break;
            case 'waveend':
                selectWidth = '24vw';
                selectHeight = '2vh';
                break;
            case 'earlyexcercise':
                selectWidth = '24vw';
                selectHeight = '2vh';
                break;
            case 'day':
                selectWidth = '12vw';
                break;
            case 'portfolios':
                selectWidth = '25vw';
                selectHeight = '4vh';
                break;
            case 'numTopOpportunitiesForEmail':
                selectWidth = '46vw';
                selectHeight = '3.3vh';
                break;
            case 'longOrShort':
                selectWidth = '10em';
                break;
            case 'monthsP':
            case 'dayP':
            case 'yearsP':
            case 'partialYearsP':
                selectWidth = '9em';
                break;
            case 'minMFEfilters':
            case 'minMFEpct':
                selectWidth = '3.5em';
                break;
            default:
                break;
        }
    }
    else if (rdd.isMobile && !rdd.isTablet && window.innerHeight < window.innerWidth) { //smartphone landscape
        selectHeight = '7.2vh';
        selectWidth = '18vw';
        switch (name) {
            case 'filter':
                selectWidth = '50vw';
                break;
            case 'months':
                selectWidth = '14vw';
                break;
            case 'years':
                selectWidth = '12vw';
                break;
            case 'monthsAndQtrs':
                selectWidth = '16vw';
                break;
            case 'daysout':
                selectWidth = '14vw';
                break;
            case 'day':
                selectWidth = '10vw';
                break;
            case 'securityTypeList':
                selectWidth = '28vw';
                break;
            case 'portfolios':
                selectWidth = '22vw';
                selectHeight = '5.4vh';
                break;
            case 'numTopOpportunitiesForEmail':
                selectWidth = '100%';
                selectHeight = '5.4vh';
                break;

            default:
                break;
        }
    }
    else if (rdd.isMobile && rdd.isTablet && window.innerHeight > window.innerWidth) { // tablet portrait
        selectWidth = '14vw';
        selectFontSize = '1.7vw';
        switch (name) {
            case 'filter':
                selectWidth = '50vw';
                break;
            case 'years':
                selectWidth = '8vw';
                suffix2 = 'yrs'
                break;
            case 'partialYears':
                selectWidth = '18vw';
                break;
            case 'securityTypeList':
                selectWidth = '30vw';
                break;
            case 'day':
                selectWidth = '7vw';
                break;
            case 'daysout':
                selectWidth = '10vw';
                suffix2 = 'days';
                break;
            case 'months':
                selectWidth = '15vw';
                break;
            case 'monthsAndQtrs':
                selectWidth = '15vw';
                break;
            case 'portfolios':
                selectWidth = '26vw';
                break;
            case 'minMFEfilters':
            case 'minMFEpct':
                selectWidth = '4.5em';
                break;
            case 'selectedDays': // this is in populate portfolio
                selectWidth = '6vw';
                break;
            case 'numTopOpportunitiesForEmail':
                selectWidth = '34vw';
                selectHeight = '2.5vh';
                break;
            default:
                break;
        }
    }
    else if (rdd.isMobile && rdd.isTablet && window.innerHeight < window.innerWidth) { //tablet landscape

        selectWidth = '10vw';
        switch (name) {
            case 'filter':
                selectWidth = '18vw';
                break;
            case 'years':
                selectWidth = '6vw';
                break;
            case 'partialYears':
                selectWidth = '9vw';
                break;
            case 'securityTypeList':
                selectWidth = '16vw';
                break;
            case 'day':
                selectWidth = '4vw';
                break;
            case 'daysout':
                selectWidth = '7vw';
                break;
            case 'months':
                selectWidth = '5vw';
                break;
            case 'monthsAndQtrs':
                selectWidth = '9vw';
                break;
            case 'portfolios':
                selectWidth = '14vw';
                break;
            case 'minMFEfilters':
            case 'minMFEpct':
                selectWidth = '4.5em';
                break;
            case 'selectedDays': // this is in populate portfolio
                selectWidth = '6vw';
                break;
            case 'numTopOpportunitiesForEmail':
                console.log('browserH=', browserH)
                if (browserW > 1024) {   //ipad pro
                    selectWidth = '19vw';
                }
                else { // regular ipad
                    selectWidth = '100%';
                }
                selectHeight = '2.5vh';
                break;
            default:
                break;
        }


    }
    else if (!rdd.isMobile) {                                       // desktop
        selectHeight = '2.7vh';
        switch (name) {
            case 'filter':
                selectWidth = '10vw';
                break;
            case 'monthsAndQtrs':
                selectWidth = '8vw';
                break;
            case 'securityTypeList':
                selectWidth = '8vw';
                break;
            case 'waveend':
                // selectWidth = '24vw';
                selectHeight = '2.1vh';
                break;
            case 'earlyexcercise':
                // selectWidth = '24vw';
                selectHeight = '2.1vh';
                break;
            case 'securityTypeListP':
                selectWidth = '11em';
                selectFontSize = '0.6vw';
                break;
            case 'daysout':
                selectWidth = '6vw';
                break;
            case 'years':
                selectWidth = '6vw';
                break;
            case 'day':
                selectWidth = '4vw';
                break;
            case 'months':
                selectWidth = '5vw';
                break;
            case 'selectedDays':
                selectWidth = '2.4vw';
                break;
            case 'minMFEfilters':
            case 'minMFEpct':
                selectWidth = '3.4vw';
                selectFontSize = '0.6vw';
                break;
            case 'numTopOpportunitiesForEmail':
                selectWidth = '12vw';
                selectHeight = '2.4vh';
                break;
            case 'longOrShort':
                selectWidth = '12em';
                break;
            case 'monthsP':
            case 'dayP':
            case 'yearsP':
            case 'partialYearsP':
            case 'tradeTypes':
                selectWidth = '9em';
                break;
            default:
                break;
        }
    }



    // console.log('name=', name)


    var ttc = '';
    var ttp = 'right';
    if (tooltipContent !== undefined) {
        ttc = tooltipContent.slice(2);
        switch (tooltipContent.substring(0, 1)) {
            case 'r': ttp = 'right'; break;
            case 'l': ttp = 'left'; break;
            case 't': ttp = 'top'; break;
            case 'b': ttp = 'bottom'; break;
            default: break;
        }
    }

    // console.log('sb value=',value)

    return (
        <div>

            <Tippy placement={ttp} content={
                <div style={{ backgroundColor: 'red', color: 'white', paddingLeft: '3px', paddingRight: '3px' }}>
                    {ttc}
                </div>
            }>
                <select onChange={sbChanged} id={name} value={value} style={{ fontSize: selectFontSize, backgroundColor: selectBackgroundColor, height: selectHeight, width: selectWidth, textAlign: textAligncustom }}>
                    {optionList.map((x) => (
                        <option key={x.id} value={x.value} style={{ fontSize: globalTextSize }}> {x.label}{suffix2} </option>
                    ))}

                </select>
            </Tippy>

        </div>
    )
}



export default SelectBox
